export const UPDATE_SYSTEM_STATUS_REQUESTED = 'UPDATE_SYSTEM_STATUS_REQUESTED';
export const UPDATE_SYSTEM_STATUS_SUCCEEDED = 'UPDATE_SYSTEM_STATUS_SUCCEEDED';
export const UPDATE_SYSTEM_STATUS_FAILED = 'UPDATE_SYSTEM_STATUS_FAILED';

export const GET_SYSTEM_STATUS_REQUESTED = 'GET_SYSTEM_STATUS_REQUESTED';
export const GET_SYSTEM_STATUS_SUCCEEDED = 'GET_SYSTEM_STATUS_SUCCEEDED';
export const GET_SYSTEM_STATUS_FAILED = 'GET_SYSTEM_STATUS_FAILED';
